import template from './checkout.html';
import controller from './checkout.controller';
import './checkout.scss';

let checkoutComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default checkoutComponent;



// WEBPACK FOOTER //
// ./client/app/components/checkout/checkout.component.js